<template>
    <div>
      <h4>Create Criteria</h4>
      <b-card>
        <h5 class="text-primary">Criteria Selection</h5>
        <b-row>
          <b-col md="6">
            <b-row>
              <b-col md="12">
                <h5 class="text-primary">Select Entity</h5>
              </b-col>
              <b-col md="10">
                <eb-select
                  style="background-color: #fff"
                  id="entity"
                  type="text"
                  label="text"
                  placeholder="Select Entity"
                  :options="entityOptions"
                  v-model="entity"
                  @input="selectEntityType"
                >
                </eb-select>
              </b-col>
            </b-row>
          </b-col>
          <b-col md="6">
            <b-row>
              <b-col md="12">
                <h5 class="text-primary">Select Criteria</h5>
              </b-col>
              <b-col md="10">
                <eb-select
                  style="background-color: #fff"
                  id="criteria"
                  type="text"
                  label="text"
                  placeholder="Select Criteria"
                  :options="criteriaOptions"
                  v-model="selectedCriteriaOptions"
                  :selected="selectedCriteriaOptions.text"
                >
                </eb-select>
              </b-col>
              <b-col md="2">
                <b-button
                  :disabled="disableCriteria"
                  @click="addCriteriaData(selectedCriteriaOptions)"
                  variant="success"
                  class="circularBtn"
                >
                  <span>
                    <i class="fa fa-plus" aria-hidden="true"></i>
                  </span>
                </b-button>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
  
        <b-row v-for="(option, index) in selectedCriteriaOption" :key="index">
          <b-col md="1">
            <label class="mt-2" :for="`operator${index}`">{{
              option.text
            }}</label>
            <label hidden :for="`operator${index}`">{{
              (criteria[index] = option.value)
            }}</label>
          </b-col>
          <b-col md="3" class="select-operator-col">
            <eb-select
              :id="`selectedOperator${index}`"
              type="text"
              label="text"
              placeholder="Select Operator"
              :options="allOperatorOptions(option,index)"
              v-model="selectedOperator[index]"
              :selected="selectedOperator[index]"
            >
            </eb-select>
          </b-col>
          <b-col md="5">
            <b-form-input
              v-if="option.value !== 'age' && option.value !== 'date'"
              :id="`operator${index}`"
              :placeholder="`Enter ${option.text}`"
              v-model="inputData[index]"
            >
            </b-form-input>
  
            <b-row style="padding: 0px 20px" v-if="option.value === 'age'">
              <range-Slider
                :id="`inputId${index}`"
                v-model="rangeValue"
                @minValue="onMinRangeChange"
                @maxValue="onMaxRangeChange"
              ></range-Slider>
              <b-form-input
                hidden
                :id="`inputId${index}`"
                :v-model="(inputData[index] = rangeValue)"
              >
              </b-form-input>
            </b-row>
  
            <b-row v-if="option.value === 'date'">
              <b-col>
                <b-row>
                  <b-col md="6">
                    <b-input
                      :id="`start-date${index}`"
                      type="date"
                      v-model="startDate"
                      @input="selectDate"
                    ></b-input>
                  </b-col>
                  <b-col md="6">
                    <b-input
                      :id="`end-date${index}`"
                      type="date"
                      v-model="endDate"
                      @input="selectDate"
                    ></b-input>
                  </b-col>
                  <b-form-input
                    hidden
                    :id="`inputId${index}`"
                    :placeholder="`Select ${option.text}`"
                    :v-model="(inputData[index] = startEndDate)"
                  >
                  </b-form-input>
                </b-row>
              </b-col>
            </b-row>
          </b-col>
          <b-col>
            <b-button
              @click="removeCriteria(index)"
              variant="success"
              class="circularBtn"
            >
              <span>
                <i class="fa fa-minus" aria-hidden="true"></i>
              </span>
            </b-button>
          </b-col>
        </b-row>
  
        <b-row class="justify-content-md-center my-2">
          <b-button
            :disabled="selectedCriteriaOption == []"
            @click="viewImpactedCustomer"
            variant="primary"
            class="w-25"
            >VIEW IMPACTED CUSTOMER</b-button
          >
        </b-row>
      </b-card>
  
      <b-row class="my-2">
        <b-col>
          <b-button variant="success" style="border-radius: 18px"
            >Impacted Customer ({{ getNewCriteria.count || 0 }})
            <span class="ml-3 mr-1">
              <i class="fa fa-angle-right" aria-hidden="true"></i>
            </span>
          </b-button>
        </b-col>
        <b-col>
          <b-button
            @click="downloadDetails"
            variant="outline-primary"
            style="float: right"
          >
            <i class="fa fa-file-text-o mx-2" aria-hidden="true"></i>Download
          </b-button>
        </b-col>
      </b-row>
      <b-card>
        <h4 class="text-primary">Notification Configuration *</h4>
        <b-row>
          <b-col>
            <eb-select
            :disabled="getNewCriteria != []"
              type="text"
              label="text"
              placeholder="Type of Notification"
              :options="typeOfNotificationOption"
              v-model="notificationOption"
              :selected="notificationOption.text"
              @input="templateTypeList"
            ></eb-select>
          </b-col>
          <b-col>
            <eb-select
            :disabled="getNewCriteria != []"
              type="text"
              label="text"
              placeholder="Template"
              :options="templateOptionList"
              v-model="templateOption"
              :selected="templateOption.text"
              @input="previewSelectedTemplate"
            >
            </eb-select>
          </b-col>
        </b-row>
        <b-row>
          <div
            contentEditable="false"
            placeholder="Preview Template"
            class="mb-3 pr-3 previewTemplate"
            v-html="showPreviewHere"
          >
        </div>
        </b-row>
        <b-row>
          <b-col md="6">
            <b-form-input
            :disabled="getNewCriteria != []"
              placeholder="Description"
              v-model="description"
            ></b-form-input>
          </b-col>
          <b-col md="2">
            <b-input
              disabled
              type="text"
              label="label"
              placeholder="Choose Effective Timestamp"
            ></b-input>
          </b-col>
          <b-col md="2">
            <b-input
            :disabled="getNewCriteria != []"
              id="time-stamp"
              type="date"
              v-model="timestampDate"
            ></b-input>
          </b-col>
          <b-col md="2">
            <b-input
            :disabled="getNewCriteria != []"
              id="time-stamp"
              type="time"
              v-model="timestampTime"
            ></b-input>
          </b-col>
        </b-row>
  
       <b-row class="my-2 justify-content-center">
        <b-button
            :disabled="getNewCriteria != []"
            @click="createBulkNotification"
            variant="primary"
            class="submit-btn-custom"
          >
           SUBMIT
       </b-button>
      </b-row>
      </b-card>
    </div>
  </template>
  
  <script>
  import ebSelect from "@/components/FormElements/Select.vue";
  import evSelect from "@/components/FormElements/Multiselect.vue";
  import rangeSlider from "@/components/FormElements/Slider.vue";
  import { mapGetters } from "vuex";
  import moment from "moment";
  export default {
    components: { ebSelect, evSelect, rangeSlider },
    data() {
      return {
        loading: false,
        previewScreen: "",
        description: "",
        myToggle: false,
        rangeValue: { gte: "", lte: "" },
        max: 100,
        startDate: "",
        endDate: "",
        startEndDate: "",
        entity: null,
        selectedCriteriaOptions: "",
        selectedCriteriaOption: [],
        operatorOptions: [],
        selectedOperator: [],
        inputData: [],
        criteria: [],
        entityOptions: [
          {
            text: "Lead Customer",
            value: "LEADCUSTOMER"
          },
          // {
          //   text: "Order",
          //   value: "ORDER",
          // },
          {
            text: "Customer",
            value: "CUSTOMER",
          },
        ],
        typeOfNotificationOption: [
          {
            text: "Sms",
            value: "SMS",
          },
          {
            text: "Email",
            value: "EMAIL",
          },
          {
            text: "Whatsapp",
            value: "WHATSAPP",
          },
          {
            text: "Inapp",
            value: "INAPP",
          },
        ],
        notificationOption: {},
        templateOption: [],
        showPreviewHere: "",
        timestampDate: "",
        timestampTime: "",
        tempPreview: "",
        temp: {}
      };
    },
  
    computed: {
      ...mapGetters({
        getListOfEntities: "bulkNotification/GetListOfEntities",
        getNewCriteria: "bulkNotification/GetNewCriteria",
        getTemplateTypeList: "bulkNotification/GetTemplateTypeList",
        getPreviewTemplate: "bulkNotification/GetPreviewTemplate",
      }),
      // allOperatorOptions() {
      //   if (this.selectedCriteriaOptions.value == "age") {
      //     return (this.operatorOptions = [
      //       {
      //         text: "Equal (eq)",
      //         value: "equal",
      //         disabled: true,
      //       },
      //       {
      //         text: "Date",
      //         value: "date",
      //         disabled: true,
      //       },
      //       {
      //         text: "Or",
      //         value: "or",
      //         disabled: true,
      //       },
      //     ]);
      //   } else if (this.selectedCriteriaOptions.value == "date") {
      //     return (this.operatorOptions = [
      //       {
      //         text: "Equal (eq)",
      //         value: "equal",
      //         disabled: true,
      //       },
      //       {
      //         text: "Date",
      //         value: "date",
      //       },
      //       {
      //         text: "Or",
      //         value: "or",
      //         disabled: true,
      //       },
      //     ]);
      //   } else
      //     return (this.operatorOptions = [
      //       {
      //         text: "Equal (eq)",
      //         value: "equal",
      //       },
      //       {
      //         text: "Date",
      //         value: "date",
      //         disabled: true,
      //       },
      //       {
      //         text: "Or",
      //         value: "or",
      //       },
      //     ]);
      // },
      templateOptionList() {
        const selectTemplate = this.getTemplateTypeList?.map((template) => ({
          text: template.concern,
          value: template?._id || "",
        }));
        return selectTemplate;
      },
      criteriaOptions() {
        const keys = this.getListOfEntities?.key || [];
        const optionList = keys.map((entity) => {
          const str = String(entity || "");
          const result = str.replace(/([A-Z])/g, " $1");
          const textValue = result.charAt(0).toUpperCase() + result.slice(1);
          return {
            text: textValue,
            value: str,
          };
        });
        return optionList;
      },
      disableCriteria() {
        let allCriteria = this.selectedCriteriaOption?.map(
          (criteriaSelect) => criteriaSelect.value
        );
        return (
          this.selectedCriteriaOptions == "" ||
          (this.selectedCriteriaOptions?.value == "age" &&
            allCriteria.includes("age")) ||
          (this.selectedCriteriaOptions?.value == "date" &&
            allCriteria.includes("date")) ||
          (this.selectedCriteriaOptions?.value == "refererId" &&
            allCriteria.includes("refererId"))
        );
      },
    },
  
    methods: {
      async selectEntityType() {
        this.loading = true;
        this.selectedCriteriaOptions = "";
        this.selectedCriteriaOption = [];
        this.operatorOptions = [];
        this.selectedOperator = [];
        this.inputData = [];
        this.criteria = [];
        if (this.entity && this.entity.value) {
          const payload = { label: this.entity.value };
          await this.$store.dispatch("bulkNotification/fetchEntities", payload);
        }
        this.loading = false;
      },
      allOperatorOptions(option, index) {
        if (option.value == "date") {
          return (this.operatorOptions[index] = [
            {
              text: "Date",
              value: "date",
            },
          ]);
        }
        if (option.value == "refererId") {
          return (this.operatorOptions[index] = [
            {
              text: "Equal (eq)",
              value: "equal",
            },
          ]);
        } else {
          return (this.operatorOptions[index] = [
            {
              text: "Equal (eq)",
              value: "equal",
            },
            {
              text: "Or",
              value: "or",
            },
          ]);
        }
      },
      async viewImpactedCustomer() {
        const checkOperatorValue = [];
        this.selectedOperator.filter((operatorValue) =>
          checkOperatorValue.push(operatorValue.value)
        );
        if (
          checkOperatorValue.includes("or") == true &&
          checkOperatorValue.includes("equal") == false
        ) {
          this.$swal({
            title: "Select Valid Operator",
            text: "For Same Criteria, Select Operator 'Equal' for the First One.",
            type: "warning",
          });
        } else if (
          this.criteria.length > 0 &&
          this.selectedOperator.length > 0 &&
          this.inputData.length > 0 &&
          this.inputData.length === this.selectedOperator.length &&
          this.criteria.length === this.selectedOperator.length
        ) {
          let criteriaData = this.criteria?.map((obj, index) => {
            if (obj === "date") {
              if (
                !this.startDate ||
                !this.endDate ||
                moment(this.startDate).diff(this.endDate, "day") > 0
              ) {
                return false;
              }
              return {
                field: obj,
                filter: this.selectedOperator[index]?.value || "",
                data: this.inputData[index],
              };
            } else {
              return {
                field: obj,
                filter: this.selectedOperator[index]?.value || "",
                data: {
                  value: this.inputData[index],
                },
              };
            }
          });
          for (const temp of criteriaData)
            if (!temp) {
              this.$swal({
                title: "Invalid Range",
                text: "Please enter a valid range.",
                type: "error",
              });
              return;
            }
          let payload = {
            collectionName: this.getListOfEntities.label,
            filterBy: criteriaData,
            retriveParams: ["name", "email", "phone"],
            serviceUrl: this.getListOfEntities.serviceUrl,
          };
          this.loading = true;
          this.showloading();
          await this.$store
            .dispatch("bulkNotification/createCriteria", payload)
            .then((result) => {
              if (this.getNewCriteria.count !== 0) {
                this.$swal({
                  title: "Successful",
                  text: "Impacted Customer's List Fetched Successfully!",
                  type: "success",
                }).then((result) => {
                  this.$router.push("/listOfCriteria");
                });
              } else {
                this.$swal({
                  title: "Error",
                  text: "Criteria does not Match! Change Criteria and Try Again.",
                  type: "error",
                });
              }
            })
            .catch((err) => {
              this.$swal({
                title: "Sorry",
                text: "Unable to Fetch Impacted Customer's List",
                type: "error",
              });
            })
            .finally(() => (this.loading = false));
        } else {
          this.$swal({
            title: "Error",
            text: "Select All Fields",
            type: "error",
          });
        }
      },
  
      onMinRangeChange(minValue) {
        this.rangeValue.gte = minValue.srcElement._value + 1;
      },
      onMaxRangeChange(maxValue) {
        this.rangeValue.lte = maxValue.srcElement._value - 1;
      },
  
      addCriteriaData(selectedCriteriaOptions) {
        this.selectedCriteriaOption.push(selectedCriteriaOptions);
      },
  
      removeCriteria(index) {
        this.criteria.splice(index, 1);
        this.selectedOperator.splice(index, 1);
        this.inputData.splice(index, 1);
        this.selectedCriteriaOption.splice(index, 1);
      },
  
      showloading() {
        this.$swal({
          showConfirmButton: false,
          allowOutsideClick: false,
          title: "Loading...",
          text: "Loading your Data. Please Wait...",
          type: "info",
        });
      },
  
      selectDate() {
        if (this.startDate !== "" && this.endDate !== "") {
          this.startEndDate = {
            gte: this.startDate,
            lte: this.endDate,
          };
        }
      },
  
      downloadDetails() {
        if (this.getNewCriteria.count && this.getNewCriteria.count !== 0) {
          window.location = this.getNewCriteria.url;
        } else {
          this.$swal({
            title: "Error",
            text: "Data Not Availavle.",
            type: "error",
          });
        }
      },
  
      async templateTypeList() {
        this.templateOption = "";
        let payload = {
          service: this.notificationOption?.value || "",
        };
        await this.$store.dispatch(
          "bulkNotification/fetchTemplateTypeList",
          payload
        );
      },
  
      async previewSelectedTemplate() {
        let payload = {
          templateId: this.templateOption.value,
        };
        await this.$store.dispatch(
          "bulkNotification/fetchTemplateToPreview",
          payload
        );
        this.showPreviewHere = this.showPreview()
        .map((pre) => pre.body)
          .join("")
          .toString();
      },
  
      showPreview() {
          let previewTemplate = this.getPreviewTemplate?.filter((preview) => (
            preview.service == this.notificationOption.value
          ));
          this.tempPreview = previewTemplate;
          return previewTemplate;
      },
  
      async createBulkNotification() {
        if (
          this.criteria.length > 0 &&
          this.selectedOperator.length > 0 &&
          this.inputData.length > 0 &&
          this.inputData.length === this.selectedOperator.length &&
          this.criteria.length === this.selectedOperator.length &&
          this.getNewCriteria.count !== 0 &&
          this.notificationOption.value &&
          this.templateOption.value
        ) {
          if (this.tempPreview[0].image) {
            this.temp = {
              _id: this.tempPreview[0]._id,
              name: this.tempPreview[0].service,
              concern: this.tempPreview[0].concern,
              body: this.tempPreview[0].body,
              subject: this.tempPreview[0]?.subject || "",
              image: this.tempPreview[0]?.image || ""
            }
          } else {
            this.temp = {
              _id: this.tempPreview[0]._id,
              name: this.tempPreview[0].service,
              concern: this.tempPreview[0].concern,
              body: this.tempPreview[0].body,
              subject: this.tempPreview[0]?.subject || "",
            }
          }
          let payload = {
            criteria: {
              filterBy: this.getNewCriteria.filterBy,
              retriveParams: this.getNewCriteria.retriveParams,
              status: this.getNewCriteria.status,
              collectionName: this.getNewCriteria.collectionName,
              serviceUrl: this.getNewCriteria.serviceUrl,
              tenant: this.getNewCriteria.tenant,
              count: this.getNewCriteria.count,
              url: this.getNewCriteria.url,
              _id: this.getNewCriteria._id,
            },
            notificationType: this.notificationOption.value,
            template: this.temp,
            description: this.description,
            scheduleDate: this.checkScheduleDate(),
          };
          await this.$store
            .dispatch("bulkNotification/createBulkNotification", payload)
            .then((result) => {
              this.$swal({
                title: "Successful",
                text: "Bulk notification Created Successfully!",
                type: "success",
              });
              this.$router.push("/listOfCriteria");
            })
            .catch((err) => {
              this.$swal({
                title: "Sorry",
                text: "Unable to Create bulk Notification",
                type: "error",
              });
            });
        } else {
          this.$swal({
            title: "Error",
            text: "Select All Fields",
            type: "error",
          });
        }
      },
      checkScheduleDate() {
        if (this.timestampDate == "" && this.timestampTime == "") {
          return "";
        } else {
          return this.timestampDate + " " + this.timestampTime;
        }
      },
    },
  
    async mounted() {
      // this.loading = true;
      // let payload = { label: "CUSTOMER" };
      // await this.$store.dispatch("bulkNotification/fetchEntities", payload);
      // this.loading = false;
    },
  };
  </script>
  <style>
  .previewTemplate {
    margin: 0px 15px;
    height: 150px;
    padding: 12px;
    border: 1px solid rgb(228, 214, 214);
    border-radius: 4px;
    min-width: 98%;
    overflow: auto;
  }
  
  .previewTemplate[contentEditable="false"]:empty:before {
    content: attr(placeholder);
  }
  
  .form-control {
    height: calc(2.2125rem + 8px);
  }
  
  .circularBtn {
    height: 40px;
    width: 40px;
    border-radius: 100%;
    text-align: center;
  }
  
  .submit-btn-custom {
    float: right;
    margin-top: 13px;
    width: 80x;
  }

  .select-operator-col {
    margin-right: 12.2rem;
  }
  
  </style>